// extracted by mini-css-extract-plugin
export default {"containprod":"CI","containprod2":"EI","title":"FI","servings":"GI","recommendation":"HI","image":"II","flavorswrap":"JI","flavorsgroupwrap":"KI","moredetailsWrap":"LI","infoWrap":"MI","price":"NI","regularPrice":"OI","netPrice":"PI","addtocartcontainer":"QI","error":"RI"};
    if(module.hot) {
      // 1737143662141
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  